<template>
<div class="w-75 mx-auto py-4 bg-white rounded">
	<h3 class="text-center">تا ۵۰ % تخفیف بگیرید</h3>
	<p style="font-size: 14px;letter-spacing:0" class="text-center">تخفیف های استثنایی در آخرین روز هر ماه</p>
	<div class="d-flex justify-content-between gap-2 align-items-center">
		<div class="w-50 text-center">
			<i class="fa fa-user" aria-hidden="true"></i>
			<h6>خانواده راداَپ</h6>
			<h6 class="counter" v-if="props.areaFlag == true"><VueJsCounter :end="members"  duration="10000" thousand=""></VueJsCounter></h6>
		</div>
		<div class="w-50 text-center">
			<i class="fa fa-calendar" aria-hidden="true"></i>
			<h6>تراکنش های موفق</h6>
			<h6 class="counter" v-if="props.areaFlag == true"><VueJsCounter :end="events"  duration="10000" thousand=""></VueJsCounter></h6>
		</div>
	
	</div>
	<p class="text-center"> اطلاع از جوایز و تخفیف های ویژه در کانال های زیر</p>
	<div class="d-flex justify-content-center gap-4 my-2">
		<div class="card border-0" >
			<a class="text-link text-center" target="_blank" href="https://t.me/online_rad_groups">
				<img src="https://radap.ir/imagesUploaded/social/telegram.jpg" class="card-img-top " style="width:3em">
				<h5 class="card-title text-center">تلگرام</h5>
			</a>
		</div>
		<div class="card border-0" >
			<a class="text-danger text-center"  target="_blank" href="https://rubika.ir/RAADAPP">
				<img src="https://radap.ir/imagesUploaded/social/rubika.jpg" class="card-img-top " style="width:3em">
				<h5 class="card-title text-center">روبیکا</h5>
			</a>
		</div>
	</div>
</div>
</template>

<script setup>
import VueJsCounter from 'vue-js-counter'
import axios from 'axios';
import {ref,defineProps} from 'vue';
let members = ref(0);
let events = ref(0);
let rewards = ref(200);
let props = defineProps(['areaFlag'])
getCounter();
function getCounter(){
    axios
    .get('https://radap.ir/Backend/api/section/pages/main/counter.php')
        .then((res)=>
        {
			members.value += parseInt(res.data.member)
			events.value = 2364 + parseInt(res.data.event);
			rewards.value = 200;
        })
}
</script>

<style scoped>
.bg-white{
	background-color: white;
}
</style>